import React from 'react'
import type { KambiHistoryCoupon } from '@mobi/api-types/kambi'
import { colors } from '@mobi/component-library/Foundations'
import { Icon } from '@mobi/component-library/Assets/Icon'
import { toMoney } from '@mobi/utils/money'
import { formatKambiCurrencyToDollarDecimal } from '@mobi/sports-offering/helpers/currency/currencyFormat'
import { BetCard } from '@mobi/betslip/Components/Common/BetCard'
import { CountdownStatus } from '@core/Areas/KambiSports/Player/Components/Coupon/Components/Common/CountdownStatus'
import { KAMBI_PENDING_HASH_ROUTE } from '@core/Areas/KambiClient/constants'

export const Multi: React.FC<{
  historyCoupon: KambiHistoryCoupon
}> = ({ historyCoupon }) => {
  const { bets, events, couponRows, outcomes } = historyCoupon

  const multiCombinedReturn = toMoney(formatKambiCurrencyToDollarDecimal(bets[0].betOdds))
  const legsCount = couponRows.length

  const firstOpenOutcome = outcomes.find(outcome => outcome.status === 'OPEN')?.eventId
  const nextLegStartTime =
    events.find(event => event.eventId === firstOpenOutcome)?.eventStartDate ?? null

  return (
    <>
      <BetCard.EventDetails
        heading='Next leg begins in:'
        statusComponent={
          <CountdownStatus
            displayType='multi-leg'
            betStatus={bets[0].betStatus}
            eventStartTime={nextLegStartTime}
          />
        }
        iconComponent={null}
      />

      <BetCard.SelectionInfo
        heading='Multi'
        subHeading={`${legsCount} Legs`}
        iconComponent={<Icon size='2.4rem' name='CustomBetslip' color={colors.neutral[800]} />}
        priceWin={multiCombinedReturn}
        linkInfo={{ pathname: KAMBI_PENDING_HASH_ROUTE }}
      />
    </>
  )
}
